var _defs, _polygon, _polyline, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalMarketingBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5dd90;\n      }\n\n      .cls-2 {\n        fill: #e7ecef;\n      }\n\n      .cls-3 {\n        fill: #ffbc0a;\n      }\n\n      .cls-4 {\n        fill: #8b8c89;\n      }\n\n      .cls-5 {\n        fill: #bc6c25;\n      }\n\n      .cls-6 {\n        fill: #a3cef1;\n      }\n\n      .cls-7 {\n        fill: #dda15e;\n      }\n\n      .cls-8 {\n        fill: #6096ba;\n      }\n\n      .cls-9 {\n        fill: #274c77;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "37.5 33.34 41.74 37.58 45.98 39 48.81 36.17 44.57 34.76 40.89 31.08 38.91 31.93 37.5 33.34"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "26.5 58.5 30.5 44.5 52.5 44.5 48.5 58.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M30.5,31.23c.29,.17,.64,.27,1,.27,1.1,0,2-.9,2-2s-.9-2-2-2c-.42,0-.81,.13-1.14,.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.08,38.54l-3,1.29c-1.01,.43-2.15,.43-3.15,0l-3-1.29c-1.47-.63-2.42-2.08-2.42-3.68v-5.36c0-3.31,2.69-6,6-6h2c3.31,0,6,2.69,6,6v5.36c0,1.6-.95,3.05-2.42,3.68Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 47.01,
    cy: 19.09,
    rx: 3,
    ry: 11,
    transform: "translate(.27 38.83) rotate(-45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.5,49c.55,0,1,.45,1,1s-.45,1-1,1v-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.5,31.23c-.29,.17-.64,.27-1,.27-1.1,0-2-.9-2-2s.9-2,2-2c.42,0,.81,.13,1.14,.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.5,41.5c0,1.66-1.34,3-3,3s-3-1.34-3-3v-2.29l1.42,.61c1.01,.44,2.15,.44,3.16,0l1.42-.61v2.29Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.5,58.5l4-14h3.14c-1.82-1.85-4.35-3-7.14-3h-3c0,1.66-1.34,3-3,3s-3-1.34-3-3h-3c-5.52,0-10,4.48-10,10v7H26.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M19.5,58.5v-2c0-1.1-.9-2-2-2h-2v4h4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.5,58.5h-2v-2c0-.55-.45-1-1-1h-7c-.55,0-1-.45-1-1v-4c0-.27,.11-.52,.29-.71l1.29-1.29c.39-.39,1.02-.39,1.41,0h0c.39,.39,.39,1.02,0,1.41l-1,1v2.59h6c1.66,0,3,1.34,3,3v2Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    height: 2,
    width: 50,
    x: 2.5,
    y: 57.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M26.9,26.88h-.01c-.57-.23-1.23-.38-2.06-.38-4.33,0-4.33,4-8.67,4-1.13,0-1.97-.27-2.66-.67v-.33c0-3.31,2.69-6,6-6h2c2.37,0,4.42,1.38,5.39,3.38h.01Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.92,17.87c1.74-.57,3.71-.16,5.09,1.22s1.78,3.35,1.22,5.09h0c-1.08-.85-2.21-1.85-3.34-2.97-1.12-1.13-2.12-2.26-2.97-3.34h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.87,28l6.1-16.05h0c-.18,1.73,2.22,5.54,5.93,9.26,3.72,3.71,7.53,6.11,9.25,5.93h.01s-15.65,6.09-15.65,6.09l-5.63-5.23Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.5,15.5h-2c0-.55-.45-1-1-1v-2c1.65,0,3,1.35,3,3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.5,15.5h-2c0-2.76-2.24-5-5-5v-2c3.86,0,7,3.14,7,7Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.5,15.5h-2c0-4.96-4.04-9-9-9v-2c6.07,0,11,4.93,11,11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.53,27.5l.64-.64c.39-.39,1.02-.39,1.41,0l5.66,5.66c.39,.39,.39,1.02,0,1.42l-1.42,1.41c-.39,.39-1.02,.39-1.41,0l-4.05-4.05c.67-.32,1.14-1.01,1.14-1.8,0-1.09-.88-1.98-1.97-2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.5,31.23v1.45c0,.47-.32,.87-.76,.97,.18,.62,.52,1.21,1.01,1.7,1.56,1.56,4.1,1.56,5.66,0l-4.05-4.05c-.26,.13-.55,.2-.86,.2-.36,0-.71-.1-1-.27Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.5,34.1l2.2-.44c.46-.09,.8-.5,.8-.98v-3.18c0-2.76-1.12-5.26-2.93-7.07s-4.31-2.93-7.07-2.93c-5.52,0-10,4.48-10,10v3c0,.55,.45,1,1,1h2v-4c0-3.31,2.69-6,6-6h2c3.31,0,6,2.69,6,6v4.6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M20.5,35.5h0c-.11-.54,.24-1.07,.78-1.18l8.22-1.64v-2.86c0-4.79-3.61-8.98-8.38-9.3-5.24-.35-9.62,3.81-9.62,8.98v3h2v2h-2c-1.1,0-2-.9-2-2v-2.68c0-5.72,4.24-10.74,9.94-11.27,6.54-.62,12.06,4.53,12.06,10.95v3.18c0,.95-.67,1.77-1.61,1.96l-8.22,1.64c-.54,.11-1.07-.24-1.18-.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketingBranding);
export default __webpack_public_path__ + "static/media/digital_marketing_branding.a4f14abeb30302a383cb297ffabac915.svg";
export { ForwardRef as ReactComponent };